export default __webpack_public_path__ + "cfc25c88cae4f9bb5defb56a802ccd39.jpg";